export const mlFaqs = [
    {
        id: "ml-faq-1",
        question: "Can I start learning without paying?",
        answer:
            "Yes! We offer the first few classes completely free. You can explore the course, experience our teaching style, and decide later if you’d like to upgrade to the advanced modules or project-based training.",
    },

    {
        id: "ml-faq-2",
        question: "How do I get started?",
        answer:
            "Just click on “Start Free Classes Now” and register. You’ll instantly get access to the free content and updates about upcoming sessions. No credit card or payment required to begin.",
    },

    {
        id: "ml-faq-3",
        question: "How much does the course cost?",
        answer:
            "The introductory classes are free. You only pay for advanced modules or project training. Fees are affordable and structured per module.",
    },

    {
        id: "ml-faq-4",

        question:
            "Is prior programming knowledge required to learn ML?",

        answer:
            "Basic Python knowledge is helpful. If you’re new, we offer foundational Python training to get you up to speed before diving into ML.",
    },
    {
        id: "ml-faq-5",

        question:
            "What are the career options after learning ML?",

        answer:
            "You can apply for roles such as:",

        list: [
            "Machine Learning Engineer",
            "AI/ML Analyst",
            "Data Scientist",
            "ML Researcher",
            "ML Ops Engineer",
        ],
    },
    {
        id: "ml-faq-6",
        question: "Will I get hands-on experience?",
        answer:
            "Yes. We focus on project-based learning. You’ll build real-time projects to understand practical implementation.",
    },

    {
        id: "ml-faq-7",
        question:
            "Will I get support if I have doubts after class hours?",
        answer:
            "Absolutely! We provide doubt-clearing sessions and post-class support via chat, calls, and email.",
    },

    {
        id: "ml-faq-8",
        question:
            "Do I get a certificate after completion?",
        answer:
            "Yes, a course completion certificate will be provided, which is helpful for your resume and job interviews.",
    },

    {
        id: "ml-faq-9",
        question:
            "What tools or IDEs will I use during this course?",

        answer:
            "You’ll use tools such as:",

        list: [
            "Jupyter Notebook",
            "Google Colab",
            "TensorFlow",
            "Keras",
            "Python",
            "Pandas",
            "NumPy",
            "Cloud-based platforms",
        ],
    },

    {
        id: "ml-faq-10",
        question:
            "What tools or software do I need?",

        answer:
            "Just Python (Anaconda), Jupyter/Colab, and a basic code editor like VS Code. We’ll guide you through all installations step-by-step.",
    },

    {
        id: "ml-faq-11",
        question:
            "Will this course help me switch careers to AI from another field?",

        answer:
            "Yes! The curriculum is designed for career transitions and covers foundational concepts through advanced AI topics along with practical project experience.",
    },

    {
        id: "ml-faq-12",
        question:
            "How much time should I dedicate weekly to succeed in this course?",

        answer:
            "We recommend 6–8 hours per week, including live sessions, practice, and project work. Flexible options are available for working professionals.",
    },

    {
        id: "ml-faq-13",
        question:
            "Are you looking to hire candidates for companies?",

        answer:
            "Yes, we specialize in helping businesses find and hire the right talent. Our HR and recruitment services are tailored to meet your company’s specific hiring needs.",

        link: {
            text: "WoCons – Custom AI & CAD Solutions",
            url: "https://wocons.com/",
        },
    },
];